// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import MobileMenu from "./partials/mobile-menu";
import CasesSwiper from "./partials/cases-swiper";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
    $wrapper.querySelectorAll('[data-header]').forEach($el => new MobileMenu($el));
    $wrapper.querySelectorAll('[data-cases]').forEach($el => new CasesSwiper($el));
}

(function() {
    window.initDom(document);
})();
